import React, { useState, useEffect } from 'react'
import AdminLeftMenu from './backend/AdminLeftMenu';
// Removed ReactSearchAutocomplete - using simple input instead
import toaster from '../helpers/toaster';
import PractitionerService from '../services/practitionerService';
import { useOutletContext,Link } from "react-router-dom";
import { useAuth } from '../contexts/AuthContext';

const current_token = localStorage.getItem('access_token');
const Physicians = () => {
  const [userData] = useOutletContext();
  const { currentUser } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [searchName, setSearchName] = useState("");
  const [searchPhysician, setSearchPhysician] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [searchSpecialty, setSearchSpecialty] = useState("");
  const [savedPractitioners, setSavedPractitioners] = useState([]);
  
  const practitionerService = new PractitionerService();

  // Load saved practitioners from Firebase
  const getSavedPractitioners = async () => {
    if (!currentUser?.uid) return;
    
    try {
      setIsLoading(true);
      const practitioners = await practitionerService.getSavedPractitioners(currentUser.uid);
      setSavedPractitioners(practitioners);
    } catch (error) {
      console.error('Error loading saved practitioners:', error);
      new toaster().errorMessage('Failed to load saved practitioners');
    } finally {
      setIsLoading(false);
  }
  };

  const searchPhysicianList = async () => {
    if (!searchName.trim()) {
      new toaster().errorMessage('Please enter a physician name to search');
      return;
    }

    try {
      setIsLoading(true);
      
      // Search using new practitioner service (FastAPI + frontend Firebase)
      const practitioners = await practitionerService.searchPractitioners(
        searchName,
        searchSpecialty,
        selectedState,
        10
      );

      if (practitioners && practitioners.length > 0) {
        // Check which practitioners are already saved - check both NPI and FHIR ID
        console.log('🔍 Checking saved status for search results...');
        console.log('Saved practitioners:', savedPractitioners.map(p => ({ npi: p.npi, fhir_id: p.fhir_id, full_name: p.full_name })));
        
        const resultsWithStatus = practitioners.map(practitioner => {
          // Check if saved by NPI or FHIR ID
          const isSavedByNPI = savedPractitioners.some(p => p.npi === practitioner.npi);
          const isSavedByFhir = savedPractitioners.some(p => p.fhir_id === practitioner.fhir_id);
          const isSaved = isSavedByNPI || isSavedByFhir;
          
          console.log(`${practitioner.full_name}: NPI=${practitioner.npi}, FHIR=${practitioner.fhir_id}, isSaved=${isSaved}`);
          
          return {
            ...practitioner,
            isSaved: isSaved
          };
        });

        setSearchPhysician(resultsWithStatus);
        new toaster().successMessage(`Found ${practitioners.length} practitioners`);
      } else {
        setSearchPhysician([]);
        new toaster().infoMessage('No practitioners found matching your search criteria');
      }
    } catch (error) {
      console.error('Error searching practitioners:', error);
      new toaster().errorMessage('Failed to search practitioners. Please try again.');
      setSearchPhysician([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getSavedPractitioners();
    return () => {
      console.log("cleanup")
    }
  }, []);
  const deleteUser = async (user) => {
    try {
      setIsLoading(true);
      
      console.log('🗑️ Attempting to remove practitioner:', user.full_name);
      console.log('Search user data:', { npi: user.npi, fhir_id: user.fhir_id });
      console.log('Saved practitioners:', savedPractitioners.map(p => ({ id: p.id, npi: p.npi, fhir_id: p.fhir_id, full_name: p.full_name })));
      
      // Find the saved practitioner by NPI or FHIR ID
      const savedPractitioner = savedPractitioners.find(p => 
        p.npi === user.npi || p.fhir_id === user.fhir_id
      );

      if (savedPractitioner?.id) {
        console.log('✅ Found saved practitioner to remove:', savedPractitioner.id);
        
        // Immediately update UI state to show "Add to Profile" button
        const updatedSearchResults = searchPhysician.map(practitioner => 
          (practitioner.npi === user.npi || practitioner.fhir_id === user.fhir_id)
            ? { ...practitioner, isSaved: false }
            : practitioner
        );
        setSearchPhysician(updatedSearchResults);
        
        const result = await practitionerService.removePractitioner(savedPractitioner.id);
        
        if (result.success) {
          new toaster().successMessage(`${user.full_name} removed from your profile`);
          
          // Refresh saved practitioners list
          await getSavedPractitioners();
        } else {
          // Revert UI state if removal failed
          const revertedSearchResults = searchPhysician.map(practitioner => 
            (practitioner.npi === user.npi || practitioner.fhir_id === user.fhir_id)
              ? { ...practitioner, isSaved: true }
              : practitioner
          );
          setSearchPhysician(revertedSearchResults);
          new toaster().errorMessage(result.message);
        }
      } else {
        console.log('❌ Practitioner not found in saved list');
        new toaster().errorMessage('Practitioner not found in your saved list');
      }
    } catch (error) {
      console.error('Error deleting practitioner:', error);
      new toaster().errorMessage('Failed to remove practitioner. Please try again.');
      
      // Revert UI state on error
      const revertedSearchResults = searchPhysician.map(practitioner => 
        (practitioner.npi === user.npi || practitioner.fhir_id === user.fhir_id)
          ? { ...practitioner, isSaved: true }
          : practitioner
      );
      setSearchPhysician(revertedSearchResults);
    } finally {
      setIsLoading(false);
        }
  };

  const AddUser = async (user_data) => {
    if (!currentUser?.uid) {
      new toaster().errorMessage('Please log in to add practitioners');
      return;
    }

    try {
      setIsLoading(true);
      
      // Immediately update UI state to show "Remove" button
      const updatedSearchResults = searchPhysician.map(practitioner => 
        (practitioner.npi === user_data.npi || practitioner.fhir_id === user_data.fhir_id)
          ? { ...practitioner, isSaved: true }
          : practitioner
      );
      setSearchPhysician(updatedSearchResults);
      
      // Save practitioner to Firebase using the new service
      const result = await practitionerService.savePractitioner(user_data, currentUser.uid);
      
      if (result.success) {
        new toaster().successMessage(`${user_data.full_name} added to your profile`);
        
        // Refresh saved practitioners list
        await getSavedPractitioners();
      } else {
        // Revert UI state if save failed
        const revertedSearchResults = searchPhysician.map(practitioner => 
          (practitioner.npi === user_data.npi || practitioner.fhir_id === user_data.fhir_id)
            ? { ...practitioner, isSaved: false }
            : practitioner
        );
        setSearchPhysician(revertedSearchResults);
        
        if (result.message?.includes('already exists')) {
          new toaster().infoMessage(`${user_data.full_name} is already in your profile`);
          // Keep as saved since it already exists
          const existingSearchResults = searchPhysician.map(practitioner => 
            (practitioner.npi === user_data.npi || practitioner.fhir_id === user_data.fhir_id)
              ? { ...practitioner, isSaved: true }
              : practitioner
          );
          setSearchPhysician(existingSearchResults);
        } else {
          new toaster().errorMessage(result.message);
        }
      }
    } catch (error) {
      console.error('Error adding practitioner:', error);
      new toaster().errorMessage('Failed to add practitioner. Please try again.');
      
      // Revert UI state on error
      const revertedSearchResults = searchPhysician.map(practitioner => 
        (practitioner.npi === user_data.npi || practitioner.fhir_id === user_data.fhir_id)
          ? { ...practitioner, isSaved: false }
          : practitioner
      );
      setSearchPhysician(revertedSearchResults);
    } finally {
      setIsLoading(false);
       }
  };

  return (
    <>
      <div className="offcanvas offcanvas-start" id="demo">
        <AdminLeftMenu />
      </div>
      <div className="rightpane mynotif">
        <div className="container">
          <div className='row justify-content-center'>
            <div className='col-md-8 text-center'>
              <img src="\images\physicianHero.png" width={'323'} alt='img-test' />
              <h2>Welcome to the Replinq physician portal. Follow the prompts below to add physicians to your profile. Surgeon schedules will then be reflected in your live calendar.</h2>
            </div>
          </div>

          
          <div className='row justify-content-center mt-4'>
            <div className='col-md-8 text-center'>
                <div className="row">
                  <div className="col-4 col-md-3">
                    <select 
                      className="form-select"
                      value={selectedState}
                      onChange={(e) => setSelectedState(e.target.value)}
                    >
                      <option value="">Select State</option>
                      <option value="CA">California</option>
                      <option value="NY">New York</option>
                      <option value="TX">Texas</option>
                      <option value="FL">Florida</option>
                      <option value="IL">Illinois</option>
                    </select>
                  </div>
                  <div className="col-4 col-md-2">
                    <select 
                      className="form-select"
                      value={searchSpecialty}
                      onChange={(e) => setSearchSpecialty(e.target.value)}
                    >
                      <option value="">Specialty</option>
                      <option value="General medical practitioner">General Practice</option>
                      <option value="Cardiology">Cardiology</option>
                      <option value="Radiology">Radiology</option>
                      <option value="Orthopedics">Orthopedics</option>
                      <option value="Pediatrics">Pediatrics</option>
                    </select>
                  </div>
                  <div className="col-4 col-md-5">
                    <input 
                      type="text"
                      className="form-control" 
                      placeholder="Type Physician Name"
                      value={searchName}
                      onChange={(e) => setSearchName(e.target.value)}
                      style={{
                          height: "36px",
                          border: "1px solid #ddd",
                        borderRadius: "0px"
                      }}
                    />
                  </div>
                  <div className="col-4 col-md-2">
                    <button 
                      className='btn btn-physearch' 
                      type="button"
                      onClick={searchPhysicianList} 
                      disabled={isLoading || !searchName.trim()}
                    >
                      {isLoading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Searching...
                        </>
                      ) : (
                        'Search'
                      )}
                    </button>
                  </div>
                </div>
              {searchPhysician.map((user, index) => (
                <div className='row mt-5' key={index}>
                  <div className='col-md-12'>
                    <div className="upschedulebox m-0">
                      <div className="uphdr">
                        <div className="dr-name phyname">
                          <div className="practitioner-info">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                              <h5 className="practitioner-name mb-0">
                                <b>{user.prefix || 'Dr.'} {user.full_name}</b>
                                {user.has_appointments && (
                                  <span className="badge ms-2" style={{fontSize: '0.6em', backgroundColor: '#E07A55', color: 'white'}}>
                                    {user.appointment_count} appointment{user.appointment_count !== 1 ? 's' : ''}
                                  </span>
                                )}
                              </h5>
                            </div>
                            
                            <p className="practitioner-specialty mb-1 text-muted">
                              {user.specialty || 'General Practice'}
                            </p>
                            {user.npi && (
                              <p className="practitioner-npi mb-0 text-muted">
                                <small>NPI: {user.npi}</small>
                              </p>
                            )}
                            
                          </div>
                        </div>
                        {user.isSaved ?
                          <div className="ms-auto">
                            <Link to='#' className='a-g-link' 
                            data-bs-toggle="modal" 
                            data-bs-target="#physiciansRemoveModal" >
                              <i className='fa fa-trash'></i> Remove
                            </Link>
                          </div>
                          :
                          <div className="ms-auto">
                            <Link to='#' className='a-g-link'  onClick={()=>{ AddUser(user)}}>
                              <i className='fa fa-plus'></i> Add to Profile
                            </Link>
                          </div>
                        }

                        <div className="modal smallsize" id="physiciansRemoveModal">
                          <div className="modal-dialog">
                            <div className="modal-content">
                              <div className="modal-body">
                                <button type="button" className="btn-close loginmdl" data-bs-dismiss="modal"></button>
                                <div className='text-center'>
                                  <span className="warningIcon"><i className="fa fa-exclamation-triangle"></i></span>
                                </div>
                                <div className='row text-center'>
                                                                  <span><b>Are you sure you want to remove {user.prefix || 'Dr.'} {user.full_name} from your profile</b></span>
                                  <p>
                                  You will no longer receive notifications for {user.prefix || 'Dr.'} {user.full_name}
                                  </p>
                                </div>
                                <div className=' row text-center'>
                                  <div className=' col-md-6 text-center'>
                                    <input type='button' data-bs-dismiss="modal" className='btn btn-primary w-100 removebtn' value='Cancel'></input>
                                  </div>
                                  <div className=' col-md-6 text-center'>
                                    <input type='button' data-bs-dismiss="modal" className='btn btn-primary w-100'  onClick={()=>deleteUser(user)} value='Confirm'></input>
                                    {/* <button>{JSON.stringify(user)}</button> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="myphy-boxleft text-start phyaddprfile">
                        <div className='row'>
                          {user.address && user.address.city && (
                            <>
                              <div className='col-1 text-end mb-3'><i className="fa fa-map-marker"></i></div>
                              <div className='col-11 mb-3 ps-0'>
                                {user.address.line?.join(', ')}<br/>
                                {user.address.city}, {user.address.state} {user.address.postal_code}
                              </div>
                            </>
                          )}
                          {user.phone && (
                            <>
                              <div className='col-1 text-end mb-3'><i className="fa fa-phone"></i></div>
                              <div className='col-11 mb-3 ps-0'>{user.phone}</div>
                            </>
                          )}
                          {user.email && (
                            <>
                              <div className='col-1 text-end'><i className="fa fa-envelope"></i></div>
                              <div className='col-11 ps-0'>{user.email}</div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              {/*<div className='row mt-5 justify-content-end'>
                <div className='col text-end'>
                  <button className='btn btn-primary' type="button">Continue</button>
                </div>
              </div>*/}
            </div>
          </div>
        </div>
      </div>
    </>
  )
};

export default Physicians;
